import { render, staticRenderFns } from "./tax-identifier-input.vue?vue&type=template&id=f6eb83d8&scoped=true"
import script from "./tax-identifier-input.vue?vue&type=script&lang=js"
export * from "./tax-identifier-input.vue?vue&type=script&lang=js"
import style0 from "./tax-identifier-input.vue?vue&type=style&index=0&id=f6eb83d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6eb83d8",
  null
  
)

export default component.exports